class CartGift extends HTMLElement {
  constructor() {
    super();

  }

  connectedCallback() {

    if (this.initialised){
      return;
    }

    this.bindElements();

    if (!this.cartDrawer && !this.cartPage){
      console.error('Cart Gift: Unable to find cart');
      return;
    }
    
    this.bindData();

    if (!this.variantId){
      console.error('Cart Gift: Unable to find variantId');
      return;
    }

    this.bindEvents();

    this.dispatchEvent(new CustomEvent('CartGift:ready', { bubbles: true }));

    this.initialised = true;
  }

  bindElements() {
    this.cartDrawer = document.querySelector('#sidebar-cart');
    this.cartPage = document.querySelector('[data-section-type="cart"]');
  }

  bindData() {
    if (this.dataset){
      this.variantId = this.dataset.variantId;
      this.quantity = this.dataset.quantity || 1;
    }
  }

  bindEvents() {
    const self = this;

    if(this.cartDrawer){
      this.cartDrawer.addEventListener('click', function(event){
        let addToCartButton = event.target.closest('.cart-milestones-gift-add');
        if (addToCartButton){
          onSubmit(addToCartButton,self.variantId,self.quantity);
        }
      });
    }
    else if (this.cartPage){
      this.cartPage.addEventListener('click', function(event){
        let addToCartButton = event.target.closest('.cart-milestones-gift-add');
        if (addToCartButton){
          onSubmit(addToCartButton,self.variantId,self.quantity);
        }
      });
    }
  }
}
if (!customElements.get('cart-gift')) {
  customElements.define('cart-gift', CartGift);
}

onSubmit = async function(addToCartButton,variantId,quantity){
  
  addToCartButton.classList.add('Link--loading');

  let formData =  {
      'items': [{
      'id': variantId,
      'quantity': quantity
    }]
  };

  const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
    body: JSON.stringify(formData),
    method: "POST",
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      'Content-Type': 'application/json'
    }
  });

  const responseJson = await response.json();
  
  if (response.ok) {
    const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
    cartContent["sections"] = responseJson["sections"];
    document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
      bubbles: true,
      detail: {
        baseEvent: "variant:add",
        onSuccessDo: "success",
        cart: cartContent
      } 
    }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
  }
  else {
    document.dispatchEvent(new CustomEvent("cart:refresh"));
  }

  addToCartButton.classList.remove('Link--loading');
}